import uuid from 'uuid'
import mergeDeepRight from 'ramda/src/mergeDeepRight'
import { defaultZoom, SATELLITE, ROADMAP } from 'helpers/globals'

const showVideos = ENV !== 'development'

const projectDefaults = _ => ({
  cameras: [],
  currentEntity: { type: 'map' },
  type: 'project',
  _id: ENV === 'test' ? '123' : uuid.v4(),
  ui: {
    sceneSettingsPanelOpen: false,
    simulatedViewPanelOpen: true,
    simulatedPersonPanelOpen: true,
    cameraDescriptionPanelOpen: false,
    advancedPanelOpen: false,
    blindSpotPanelOpen: false,
    sidebarView: 'cameraDetails',
    modal: null,
    deviceLimitType: null,
    ppfHover: {},
    showCameraBlindspot: false,
    showSideBar: true,
    showBottomInputRow: false,
    titleChanged: false,
    scaling: false,
    floorPlanScaleID: null,
    tutorialVideoPanelOpen: showVideos,
    scalingVideoPanelOpen: showVideos,
    hideDiscontinuedModels: true,
    hideNdaaNonCompliantModels: false,
    showAnalyticZones: true,
    showSimpleCameraIcon: false,
    cameraViewsChoice: 'All Cameras',
    showWallBlindspots: false,
    isImperial: true,
    viewOptionsPanelOpen: false,
    drawingWall: false,
    measurementTool: false,
    drawingMeasurement: false,
    drawingWire: false,
    wallVideoPanelOpen: showVideos,
    mapLoaded: false,
    wiringPanelOpen: false,
    wiringVideoPanelOpen: showVideos,
    wiredDeviceVideoPanelOpen: showVideos,
    offlineTimeLimit: false,
    doorControllerSummaryPanelOpen: false,
    doorDetailsPanelOpen: false
  },
  createdAt: ENV === 'test' ? 45678910 : Date.now(),
  updatedAt: ENV === 'test' ? 45678910 : Date.now(),
  zoom: defaultZoom,
  map: {
    floorPlans: [],
    markups: []
  },
  location: { lat: 40.7493242889004, lng: -73.96888876455688 },
  mapType: ENV === 'development' ? ROADMAP : SATELLITE,
  exportType: null,
  messages: {},
  title: 'New Project',
  entities: {
    auxiliaryInputs: {
      byId: {},
      allIds: []
    },
    auxiliaryOutputs: {
      byId: {},
      allIds: []
    },
    contacts: {
      byId: {},
      allIds: []
    },
    doors: {
      byId: {},
      allIds: []
    },
    doorControllers: {
      byId: {},
      allIds: []
    },
    doorOpeners: {
      byId: {},
      allIds: []
    },
    locks: {
      byId: {},
      allIds: []
    },
    networkClosets: {
      byId: {},
      allIds: []
    },
    readers: {
      byId: {},
      allIds: []
    },
    rexs: {
      byId: {},
      allIds: []
    },
    tampers: {
      byId: {},
      allIds: []
    },
    wiredDevices: {
      byId: {},
      allIds: []
    },
    wires: {
      byId: {},
      allIds: []
    }
  }
})

export const addProjectDefaults = mergeDeepRight(projectDefaults())
export default projectDefaults



// WEBPACK FOOTER //
// ./src/helpers/projects/projectDefaults.js